import Reveal from "reveal.js";
export function addSlide(slide, position) {
    const slides = document.querySelector(".slides");
    const loading = document.querySelector("#loading");
    // TODO: is this necessary with the sync below now?
    slide.setAttribute("hidden", "true");
    slide.classList.add("future");
    if (position === "prepend") {
        slides.prepend(slide);
    }
    else {
        slides.append(slide);
    }
    if (loading) {
        // remove loading indicator
        loading.remove();
    }
    if (Reveal === null || Reveal === void 0 ? void 0 : Reveal.sync) {
        Reveal.sync();
        loading && Reveal.slide();
    }
}
